import { useEffect, type ReactNode } from 'react';

export function Modal({ title, children, onClose, destructive = false }: { title: string; children: ReactNode; onClose?: () => void; destructive?: boolean }) {
  useEffect(() => {
    const listener = (event: KeyboardEvent) => { if (event.key === 'Escape' && !destructive) onClose?.(); };
    window.addEventListener('keydown', listener);
    return () => window.removeEventListener('keydown', listener);
  }, [destructive, onClose]);
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => { if (event.currentTarget === event.target && !destructive) onClose?.(); }}>
      <section className="modal" role="dialog" aria-modal="true" aria-labelledby="modal-title">
        <h2 id="modal-title">{title}</h2>
        {children}
      </section>
    </div>
  );
}
